/**
 * Cómo se llaman, de cara al cliente, las compañías (las entidades legales) y los
 * productos. En la base de datos van con su nombre corto («Software del Sol»,
 * «CONTASOL»); aquí se les da el nombre comercial que se enseña en el portal.
 */

/** Nombre comercial por código de compañía, cuando no basta con anteponer «TeamSystem». */
const COMPANIAS: Record<string, string> = {
  SDELSOL: 'TeamSystem Software Delsol',
};

/** Nombre comercial de los productos de Software Delsol, por su nombre en el catálogo. */
const PRODUCTOS: Record<string, string> = {
  CONTASOL: 'TeamSystem Contasol',
  CRMSOL: 'TeamSystem CRM',
  DELSOL: 'TeamSystem Delsol',
  FACTUSOL: 'TeamSystem Factusol',
  GDE: 'TeamSystem Gestión de Empleados',
  NOMINASOL: 'TeamSystem Nominasol',
  REVISO: 'TeamSystem Delsol Reviso',
  TPVSOL: 'TeamSystem TPVsol',
};

/** Nombre de la compañía con «TeamSystem» delante, salvo que ya lo lleve («TS Facturas»). */
export function nombreDeCompania(entidad: { codigo: string; nombre: string }): string {
  const propio = COMPANIAS[entidad.codigo];
  if (propio !== undefined) return propio;
  return entidad.nombre.startsWith('TS ') ? entidad.nombre : `TeamSystem ${entidad.nombre}`;
}

/** Nombre del producto; los que no están en la lista se enseñan tal cual. */
export function nombreDeProducto(nombre: string): string {
  return PRODUCTOS[nombre.trim().toUpperCase()] ?? nombre;
}
